<template>
  <div class="page-login">
    <!-- 中部 -->
    <PageHeader />
    <div class="login-center">

      <div class="login-center-b">
        <!-- <div v-if="loginTestAB === 'A'" class="login-dialog-container login-wrap ">
          <div class="login-title">登入/註冊</div>
          <div class="login-gift">
            <img src="~@/assets/images/login-gift.png" alt="">
            <p>現在註冊即可免費體驗一次陪玩，馬上行動</p>
          </div>
          <div class="login-body">
            <div class="login-body-line mobile">
              <div class="mobile-prefix"
              >
                <el-popover
                  v-model="isShowMobileAreaSelectList"
                  :visible-arrow="false"
                  popper-class="popper-clear-style"
                  placement="bottom-start"
                >
                  <div slot="reference" class="mobile-prefix-inner">
                    <span>{{ currentSelectPrefix.code }}</span>
                    <img src="~@/assets/images/select-icon.png" alt="" />
                  </div>
                  <div
                    class="login-body-mobile-area"
                    v-clickoutside="closeMobileAreaSelectList"
                  >
                    <p
                      v-for="(item, index) in mobileAreaList"
                      :key="index"
                      @click="selectMobileArea(item.code)"
                    >
                      <span>{{ item.text }}</span>
                      <span>{{ item.code }}</span>
                    </p>
                  </div>
                </el-popover>
              </div>
              <div class="mobile-input">
                <input
                  v-model="loginObj.phoneNumber"
                  type="text"
                  placeholder="請輸入手機號碼"
                />
              </div>
            </div>
            <div class="login-body-line code">
              <div class="valid-code">
                <input
                  v-model="loginObj.verifyCode"
                  type="text"
                  placeholder="請輸入認證碼"
                />
              </div>
              <div class="btn">
                <button :class="!sendCodeTimer && !isSendingSmsCode && 'button-hover'" :disabled="sendCodeTimer > 0" @click="getValidateCode">
                  <span v-if="isSendingSmsCode">
                    <i class="el-icon-loading"></i>
                    發送中
                  </span>
                  <span v-else>{{
                    sendCodeTimer > 0
                      ? "重新傳送(" + sendCodeTimer + ")"
                      : "獲取認證碼"
                  }}</span>
                </button>
              </div>
            </div>
            <div class="login-body-operation">
              <p @click="changeIsKeepLoginStatus">
                <img :src="isKeepLoginStatus ? checked : unchecked" alt="" />
                <span>記住登入</span>
              </p>
            </div>
          </div>
          <div class="login-footer">
            <button @click="login" class="primary-btn">
              <i class="el-icon-loading" v-if="isLogining"></i>
              <span v-else>立即登入</span>
            </button>
          </div>
          <ThirdPary
            @closeLogin="visible=false"
            @jump_redirect="success"
            :isSaveToken="isKeepLoginStatus"
            :pagelogin="true"
            :redirectPath="redirect"
          />
          <div class="login-protocol">
            <p>登入即代表您同意<span @click="jumpPage('/compact')">nicee用戶協議</span>及<span @click="jumpPage('/privacy')">隱私權政策</span></p>
          </div>
        </div>
        <div v-else class="login-wrap-B"> -->
        <div class="login-wrap-B">
          <p class="top-text">{{$t('upgrade_page_views_login_index_1092')}}</p>
          <ThirdParyNew
            @closeLogin="visible=false"
            @jump_redirect="success"
            :isSaveToken="isKeepLoginStatus"
            :pagelogin="true"
            :redirectPath="redirect"
          />
          <!-- <p class="or">或</p> -->
          <p class="phone-login" @click="phoneLogin">{{$t('components_login_components_phone_login_1076')}}</p>
          <div class="login-protocol">
            <p>{{$t('components_login_index_1090')}}<span @click="jumpPage('/compact')">{{$t('upgrade_page_views_login_index_1093')}}</span>{{$t('upgrade_page_views_login_index_1094')}}<span @click="jumpPage('/newprivacy')">{{$t('upgrade_page_views_login_index_1095')}}</span></p>
          </div>
        </div>

      </div>
    </div>
    <div id="verification-code"></div>
    <phoneLogin
      :redirect="redirect"
      :phoneLoginDialog="phoneLoginDialog"
      @closePhoneLogin="closePhoneLogin"
      @successLogin="success()"
      :pagelogin="true"
    />
    <PageFooter/>
  </div>
</template>
<script>
import i18n from '@/locales/index'

import store from "@/store/index"
import { getSmsCode } from "@/api"
import Clickoutside from "@/utils/clickoutside"
import mobileAreaList from '@/utils/areas-code'
// import ThirdPary from '@/components/Login/components/thirdpary.vue'
import ThirdParyNew from '@/components/Login/components/thirdpary-new.vue'
import phoneLogin from '@/components/Login/components/phone-login.vue'
import PageHeader from '@/upgrade-page/layout/header'
import PageFooter from '@/upgrade-page/layout/footer'
import { mapGetters } from 'vuex'
export default {
  name: "Login",
  directives: {
    clickoutside: Clickoutside
  },
  components: {
    // ThirdPary,
    ThirdParyNew,
    phoneLogin,
    PageHeader,
    PageFooter,
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data() {
    return {
      redirect: this.$route.query && this.$route.query.redirect || '/',
      isKeepLoginStatus: true,
      isShowMobileAreaSelectList: false,
      mobileAreaList: mobileAreaList,
      currentSelectPrefix: {
        code: 1
      },
      isSendingSmsCode: false,
      isLogining: false,
      sendCodeTimer: 0,
      visible: true,
      loginObj: {
        phoneNumber: "",
        verifyCode: "",
        keyUuid: null
      },
      tencentCaptchaInstance: null,
      phoneLoginDialog: false,
    }
  },
  created() {
    if(this.userInfo) {
      this.$router.push({
        path: '/'
      })
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    },
  },
  methods: {
    closePhoneLogin(res){
      this.phoneLoginDialog = res
    },
    phoneLogin() {
      this.phoneLoginDialog = true
    },
    jumpPage(page) {
      this.$router.push(page)
    },
    /**
     * @description 是否记住登录状态
     */
    changeIsKeepLoginStatus() {
      this.isKeepLoginStatus = !this.isKeepLoginStatus
    },
    toggleMobileAreaSelectList() {
      this.isShowMobileAreaSelectList = !this.isShowMobileAreaSelectList
    },
    closeMobileAreaSelectList() {
      this.$nextTick(() => {
        if (this.isShowMobileAreaSelectList) {
          this.isShowMobileAreaSelectList = false
        }
      })
    },
    selectMobileArea(code) {
      this.currentSelectPrefix.code = code
      this.closeMobileAreaSelectList()
    },
    /**
     * @description 獲取驗證碼
     */
    getValidateCode() {
      const { phoneNumber } = this.loginObj

      if (!phoneNumber) return this.$message.error(i18n.t('upgrade_page_views_user_set_account_783'))

      if (!this.tencentCaptchaInstance) {
        this.tencentCaptchaInstance = new window.TencentCaptcha(document.querySelector('#verification-code'), process.env.VUE_APP_VERIFICATION_APPID, resp => {
          if (resp.ret === 0) {
            this.isSendingSmsCode = true
            const { phoneNumber } = this.loginObj
            const { code } = this.currentSelectPrefix

            getSmsCode({
              phoneNumber: code + phoneNumber,
              ticket: resp.ticket,
              rand: resp.randstr
            }).then(({ data }) => {
              if (data) {
                this.loginObj.keyUuid = data
                this.setSmsCodeInterval(30)
              }

              this.isSendingSmsCode = false
            }).catch(err => {
              this.isSendingSmsCode = false
              if (err.msg) {
                this.$message.error(err.msg)
              }
            })
          }
        })
      }

      this.tencentCaptchaInstance.show()
    },
    /**
     * @description 設置發送驗證碼倒計時
     */
    setSmsCodeInterval(count) {
      this.sendCodeTimer = count

      if (count > 0) {
        setTimeout(this.setSmsCodeInterval.bind(this, --count), 1000)
      }
    },
    /**
     * @description 校驗輸入輸入內容
     */
    validateInputMsg() {
      const { phoneNumber, verifyCode, keyUuid } = this.loginObj
      const { code } = this.currentSelectPrefix

      if (!phoneNumber) {
        this.$message.error(i18n.t('upgrade_page_views_user_set_account_801'))
        return false;
      }
      if (verifyCode.length !== 4) {
        this.$message.error(i18n.t('upgrade_page_views_user_set_account_785'))
        return false;
      }

      let inviterUnique = window.localStorage.getItem('STORAGE_INVITER_UUID') || null
      if (!inviterUnique) {
        const str = sessionStorage.getItem('INVITE_UNIQUE')
        str && (inviterUnique = JSON.parse(str).inviterUnique)
      }
      return {
        phoneNumber: code + phoneNumber,
        verifyCode,
        keyUuid,
        isSaveToken: this.isKeepLoginStatus,
        inviterUnique,
      };
    },
    /**
     * @description 登陸
     */
    async login() {
      const params = this.validateInputMsg()
      if (params && !this.isLogining) {
        this.isLogining = true
        window.fbq('track', 'SubmitApplication')
        try {
          await store.dispatch("app/login", params)
          this.isLogining = false
          this.visible = false
          this.success()
        } catch (e) {
          this.isLogining = false
        }
      }
    },
    success() {
      this.$router.replace({ path: decodeURIComponent(this.redirect) || '/' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .button-hover:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(167.68deg, #FF4417 2.04%, #FB006E 60.91%) !important;
  }
  .page-login {
    width: 100%!important;
    height: 100vh!important;
    display: flex;
    flex-direction: column;
    .login-center {
      flex: 1;
      position: relative;
      background-image: url('~@/assets/images/loginbacimage.jpg');
      background-repeat: no-repeat;
      background-size: cover; 
      .login-center-b {
        position: absolute;
        right: 125px;
        top: 150px;
        .login-dialog-container {
          & /deep/ .el-dialog__header {
            padding: 0;
          }

          & /deep/ .el-dialog__body {
            padding-bottom: 88px;
          }
        }

        .login-wrap {
          width: 386px;
          min-height: 422px;
          padding: 30px 20px;
          // padding: 30px 20px 88px;
          background: #ffffff;
          box-shadow: 0px 4px 10px rgba(93, 100, 172, 0.12);
          border-radius: 8px;

          .login-title {
            color: #333;
            font-weight: 500;
            line-height: 28px;
            margin-bottom: 10px;
            text-align: center;
            // margin-top: 40px;
          }
          .login-gift {
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 16px;
            text-align: center;
            color: #82BE2F;
            img {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }
          }

          .login-body {
            position: relative;
            padding: 30px 28px 0;
            // border-top: 1px solid #e0e0e0;
          }

          .login-footer {
            margin: 20px auto 0;

            button {
              @include flex();
              width: 290px;
              height: 46px;
              margin: auto;
            }
          }

          .login-protocol {
            margin-top: 20px;
            font-size: 13px;
            line-height: 18px;
            color: #666;
            text-align: center;

            span {
              cursor: pointer;
              text-decoration: underline;
              color: $color-gray-1;
            }
          }

          .login-body-line {
            @include flex();
            height: 46px;
            border-radius: 4px;
            font-size: 16px;

            > div {
              @include flex();
              height: 100%;
            }

            &.mobile {
              border: 1px solid #999999;
              padding: 0 13px 0 0;
            }

            &.code {
              margin-top: 20px;
            }

            input {
              width: 100%;
              height: 100%;
              color: #333;
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
            }

            .mobile-prefix {
              width: 55px;
              flex-shrink: 0;
              cursor: pointer;

              .mobile-prefix-inner {
                @include flex(space-between);
                width: 58px;
                padding-left: 13px;
                span {
                  font-weight: 500;
                  font-size: 16px;
                  color: #333333;
                }
              }

              img {
                width: 10px;
                margin-left: 2px;
              }
            }

            .mobile-input {
              flex-grow: 1;
              margin-left: 14px;
              input{
                -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
              }
            }

            .valid-code {
              width: 164px;
              border: 1px solid #999;
              border-radius: 4px;
              padding: 0 13px;
            }

            .btn {
              width: 116px;
              margin-left: 10px;

              button {
                @include flex();
                width: 100%;
                height: 100%;
                color: white;
                font-weight: 500;
                font-size: 16px;
                line-height: 22px;
                border-radius: 4px;
                cursor: pointer;
                background: linear-gradient(
                  151.37deg,
                  #ff4417 2.04%,
                  #fb006e 60.91%
                );
              }
            }
          }

          .login-body-operation {
            display: inline-block;
            font-size: 0;
            margin-top: 30px;

            p {
              @include flex(flex-start);
              cursor: pointer;
            }

            img {
              width: 14px;
              height: 14px;
              margin-right: 6px;
            }

            span {
              font-size: 13px;
              color: #666;
              line-height: 18px;
            }
          }
        }
        .login-wrap-B {
          width: 386px;
          min-height: 422px;
          background: #ffffff;
          padding: 30px 20px;
          box-shadow: 0px 4px 10px rgba(93, 100, 172, 0.12);
          border-radius: 8px;
          /deep/ .fb-login {
            margin-top: 32px;
          }
          .or {
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            line-height: 75px;
            height: 75px;
            text-align: center;
            color: #CCCCCC;
          }
          .phone-login {
            height: 48px;
            width: 280px;
            margin: 16px auto 30px;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 48px;
            text-align: center;
            color: #333333;
            cursor: pointer;
            background: #FFFFFF;
            box-shadow: 0px 0.8px 4px rgba(0, 0, 0, 0.1);
            border-radius: 30px;
          }
          .login-protocol {
            margin-top: 20px;
            font-size: 13px;
            line-height: 18px;
            color: #666;
            text-align: center;

            span {
              cursor: pointer;
              text-decoration: underline;
              color: #FA006E;
            }
          }
        }
      }
    }
  }

  .login-body-mobile-area {
    width: 290px;
    height: 228px;
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #999;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

    p {
      @include flex(space-between);
      color: #333;
      font-size: 16px;
      height: 38px;
      margin: 0;
      padding: 0 9px;
      font-weight: 400;
      transition: all 0.2s ease;
      cursor: pointer;
      background: white;

      &:hover {
        background: #f6f6f6;
      }

      span:first-child {
        @include ellipsis;
      }
    }
  }
  .top-text {
    position: absolute;
    top: -70px;
    left: 0;
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
  }
</style>
